import { getChainContracts } from "@/shared/config/blockchain/helpers";
import { useWeb3State } from "@/web3/context";
import { MutationArgs } from "../types";
import useERC20ApprovalMutation from "./useERC20ApprovalMutation";

export default function useExchangeERC20ApprovalMutation(
  tokenAddress?: string,
  mutationArgs: MutationArgs = {},
) {
  const { chainId } = useWeb3State();

  const contracts = getChainContracts(chainId);

  return useERC20ApprovalMutation(
    tokenAddress,
    contracts?.exchangeAddress,
    mutationArgs,
  );
}
